var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "open-plat" }, [
      _c("div", { staticClass: "open-header-wrap" }, [
        _c("div", { staticClass: "header-layout clearfix" }, [
          _c("div", { staticClass: "header-layout-side" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "app-url",
                    rawName: "v-app-url",
                    value: "/",
                    expression: "'/'"
                  }
                ],
                staticClass: "header-layout-logo"
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "resc-url",
                      rawName: "v-resc-url",
                      value: "/image/logo.png",
                      expression: "'/image/logo.png'"
                    }
                  ],
                  attrs: { title: "商维宝开放平台" }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("商维宝开放平台")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "banner-wrap" }, [
        _c("div", { staticClass: "banner-layout clearfix" }, [
          _c("div", { staticClass: "login-layout" }, [
            _c(
              "div",
              { staticClass: "login-area" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "user",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.user, rules: _vm.rules },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.submitForm("user")
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "login-form-panel" },
                      [
                        _c("el-form-item", { attrs: { prop: "phoneNo" } }, [
                          _c(
                            "div",
                            { staticClass: "login-input" },
                            [
                              _c("el-input", {
                                staticClass: "font14",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入手机号码或集团编码",
                                  "auto-complete": "off"
                                },
                                model: {
                                  value: _vm.user.phoneNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "phoneNo", $$v)
                                  },
                                  expression: "user.phoneNo"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("el-form-item", { attrs: { prop: "password" } }, [
                          _c(
                            "div",
                            { staticClass: "login-input" },
                            [
                              _c("el-input", {
                                staticClass: "font14",
                                attrs: {
                                  type: "password",
                                  placeholder: "密码",
                                  "auto-complete": "off"
                                },
                                model: {
                                  value: _vm.user.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "password", $$v)
                                  },
                                  expression: "user.password"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "login-help-panel clearfix" }, [
                      _c("label", { staticClass: "checkbox-label" }, [
                        _c("input", { attrs: { type: "checkbox" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml5" }, [_vm._v("记住账号")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "login-btn-panel" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "swb-btn swb-btn-small",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.submitForm("user")
                              }
                            }
                          },
                          [_vm._v("登录")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-title" }, [
      _c("span", [_vm._v("登录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bbfe25b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbfe25b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/entry/userLogin/main.vue
// module id = 881
// module chunks = 18